import { create } from 'zustand';

/** Shared tour state used by field advisors and content editors. */
interface ClaireWidgetState {
  isTourRunning: boolean;
  setTourRunning: (running: boolean) => void;
}

export const useClaireWidgetState = create<ClaireWidgetState>()((set) => ({
  isTourRunning: false,
  setTourRunning: (running) => set({ isTourRunning: running }),
}));
